import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Badge, Button, Col, Collapse, Row} from 'reactstrap';
import Moment from "moment"
import {Link} from "react-router-dom"

class ItemConversion extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {collapse: false};
    }

    toggle() {
        this.setState({collapse: !this.state.collapse});
    }

    render() {
        const {conversion, handleClick} = this.props;
        const disabled = conversion.status !== 'pending';
        const now = Moment();
        const createdTime = Moment(conversion.created);
        const backwardTime = Moment.duration(createdTime.diff(now));
        const badgeColorMap = {
            approved: 'success',
            rejected: 'danger',
            pending: 'warning',
            nothing: 'light'
        }
        return (
            <tbody className="ItemConversion">
            <tr onClick={this.toggle} className="cursor-pointer">
                <td>{conversion.bill.title}</td>
                <td><Link to={'/a/users/'.concat(conversion.payer._id)}> {conversion.payer.name}</Link></td>
                <td><Link to={'/a/users/'.concat(conversion.broker._id)}> {conversion.broker.name}</Link></td>
                <td><Badge color={badgeColorMap[conversion.status]}>{conversion.status}</Badge></td>
                <td>{'$' + conversion.earned}</td>
                <td>
                    <div className='tooltip-container'>{backwardTime.humanize(true)}
                        <span
                            className="tooltip-text">{createdTime.format('DD-MM-YYYY')}</span>
                    </div>
                </td>
            </tr>

            <tr>
                {/* TODO: When add td to tr. Edit colSpan */}
                <td colSpan="6">
                    <Collapse isOpen={this.state.collapse}>
                        <Row>
                            <Col>
                                <p>Total: {conversion.total}</p>
                                <p>Click IP: {conversion.click.IP}</p>
                            </Col>
                            <Col>
                                <span>Broker:</span>
                                <ul>
                                    <li>name: {conversion.broker.name}</li>
                                    <li>email: {conversion.broker.email}</li>
                                </ul>
                            </Col>
                            <Col>
                                <span>Payer:</span>
                                <ul>
                                    <li>name: {conversion.payer.name}</li>
                                    <li>email: {conversion.payer.email}</li>
                                </ul>
                            </Col>
                        </Row>
                        {
                            disabled ? <div/> : <div>
                                <Button
                                    // className="loading-affiliate"
                                    color="primary"
                                    onClick={handleClick(conversion, 'approved')}
                                    disabled={disabled}>
                                    <i className="fas fa-check"/>
                                </Button>
                                <Button
                                    color="danger"
                                    onClick={handleClick(conversion, 'rejected')}
                                    disabled={disabled}>
                                    <i className="fas fa-times"/>
                                </Button>{' '}</div>
                        }

                    </Collapse>
                </td>
            </tr>


            </tbody>
        );
    }
}

ItemConversion.propTypes = {
    conversion: propTypes.object.isRequired,
    handleClick: propTypes.func.isRequired
}

export default ItemConversion;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/conversion/ItemConversion.js